module.exports = __webpack_public_path__ + "static/media/hpb-os1-studio.a52b5a5d.jpg";